import { postApi } from "../base.api.js";

export const loginPost = async(username, password) => {
    const response = await postApi('auth/login', { username, password });
    console.log('Login response:', response);
    return response;
}